import React, { FC } from 'react'
import styled from 'styled-components'
import { WasteType } from '../../../core/domain/models'
import { WasteTypeIcon } from '../../shared'

interface WasteListProps {
  wastes: WasteType[]
}

const WasteList: FC<WasteListProps> = (props) => {
  const { wastes } = props

  return (
    <Container>
      {wastes.map((waste, index) => {
        const { name, picture } = waste
        return (
          <WasteWrapper key={index}>
            <WasteTypeIcon name={name} picture={picture} />
            <NameWrapper>
              <Name>{name}</Name>
            </NameWrapper>
          </WasteWrapper>
        )
      })}
    </Container>
  )
}

const Container = styled.div`
  overflow: auto;
  height: 257px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-bottom: 12px;
`

const WasteWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
`
const NameWrapper = styled.div`
  display: flex;
  align-items: center;
`

const Name = styled.p`
  font-weight: ${({ theme }) => theme.weight.normal};
  font-size: ${({ theme }) => theme.size.small};
  line-height: 1.8em;
`

export default WasteList
